import { inheritLegacyBrandButtons } from './legacyBrandButtons';
// Button defaults belong to the preview, not to the saved configuration.
// Only an explicit override should stop a button inheriting its app color.
export function mergeAccountBranding(defaults, saved = {}) {
  return Object.fromEntries([...new Set([...Object.keys(defaults), ...Object.keys(saved)])].map(type => {
    const branding = { ...defaults[type], ...saved[type] };
    if (type === 'admin' || type === 'superadmin') {
      branding.buttonStyles = inheritLegacyBrandButtons(saved[type]?.buttonStyles, type, branding.primaryColor);
    }
    return [type, branding];
  }));
}
